import { render, staticRenderFns } from "./passResetOkPage.vue?vue&type=template&id=1c28b5ca"
import script from "./passResetOkPage.vue?vue&type=script&lang=ts"
export * from "./passResetOkPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports